import { createFileRoute, redirect } from '@tanstack/react-router';

// FSU shell unification: the pre-FSU /setup URL is retired. Setup lives
// under the new Settings sub-nav. Existing bookmarks redirect.
export const Route = createFileRoute('/admin/finance/setup')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/finance/settings/setup' });
  },
});
